import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './styles/tokens.css'
import './styles/glass.css'
import './styles/bubble.css'
import './styles/room-chat.css'

createApp(App).use(router).mount('#app')
